import axiosClient from "../axiosClient";
import axiosClient_v2 from "../axiosClient_v2";

export const alprService = {
  edit: (data) => {
    return axiosClient.post("/camALPR/post-license-plate-cam-alpr/", data);
  },
  getCrop: (params) => {
    return axiosClient.get("/camALPRCropRegion/get-list-cam-alpr-crop-region/", {
      params: {
        camera_code: params.camera_code
      }
    })
  },
  getNotification: (params) => {
    return axiosClient_v2.get('/camALPR/get-list-cam-alpr/', {
      params
    })
  }
};
